import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ChevronUpIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M14.76 11.48a1.843 1.843 0 0 1 2.48 0l8.438 7.785a1 1 0 0 1-1.356 1.47L16 13.057l-8.322 7.678a1 1 0 0 1-1.356-1.47l8.437-7.785Z" />
  </BaseIcon>
);
